import React, { useState } from 'react';
import { motion } from 'framer-motion';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';
import QuizModal from './QuizModal';

const { FiMessageCircle } = FiIcons;

const FloatingCTA = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);

  return (
    <>
      <motion.div
        initial={{ scale: 0 }}
        animate={{ scale: 1 }}
        transition={{ delay: 2, type: 'spring' }}
        className="fixed bottom-6 right-6 z-40"
      >
        <motion.button
          whileHover={{ scale: 1.05 }}
          whileTap={{ scale: 0.95 }}
          className="bg-brand-blue text-white px-6 py-4 rounded-full shadow-2xl hover:bg-brand-gold transition-all flex items-center space-x-3 border border-brand-gold/30"
          onClick={() => setIsModalOpen(true)}
        >
          <SafeIcon icon={FiMessageCircle} className="h-6 w-6 text-brand-gold" />
          <span className="hidden sm:block font-black uppercase tracking-widest text-xs">
            Contatta Castello SRL
          </span>
          <span className="sm:hidden font-black uppercase tracking-widest text-xs">
            Candidati
          </span>
        </motion.button>
      </motion.div>

      <QuizModal isOpen={isModalOpen} onClose={() => setIsModalOpen(false)} />
    </>
  );
};

export default FloatingCTA;